import Service from "./service";

export const demoScript = (script) => (dispatch) => {
  Service.post(dispatch, "tools/scripts/", script, {
    init: "START_SCRIPTS",
    success: "START_SCRIPTS_SUCCESS",
    error: "START_SCRIPTS_FAILED",
  });
};
